export const appMixin = {
  data() {
    return {
      appName: 'Virelia',
      appStoreLink: 'itms-apps://itunes.apple.com/app/id6751053024',
      primaryColor: '#5cc0c8',
      termsOfService: 'https://virelia.vip/desktop/terms_of_service',
      privacyPolicy: 'https://virelia.vip/desktop/privacy_policy',
      email: "ghsuddnbc@gmail.com",
      org: '',
      orgAdress: '',
      discord: 'https://discord.gg/wXzEPjUtbS',
      shopLink: {
        pre: 'https://pre-shop.cozytaps.com',
        online: 'https://shop.cozytaps.com'
      }
    }
  },

  methods: {
    getShopDomain() {
      return this.shopLink[APP_ENV.VUE_APP_ENVIRONMENT] || this.shopLink.pre;
    }
  }
}